import { Component, OnInit } from '@angular/core';
import { GalleryPageServiceService } from '../gallery-page/gallery-page-service.service';


declare var bootbox: any;
declare var $: any;

@Component({
  selector: 'app-home-page',
  templateUrl: './home-page.component.html',
  styleUrls: ['./home-page.component.scss']
})
export class HomePageComponent implements OnInit {
  constructor(private GalleryPageService: GalleryPageServiceService) {}
   isCollapsed = true; 
  currentIndex = 0;
  images: any[] = [];

  ngOnInit() {
    this.loadGallery();
  }

  loadGallery(): void {
    this.GalleryPageService.getJobImage().subscribe(
      (data) => {
        this.images = data;
      },
      (error) => {
        console.error('Error loading gallery', error);
      }
    );
  }
}
